import { ref } from 'vue'
import { updateOwnStatus, type AgentAvailability } from '@/services/wootdashAgents'

export type AvailValue = 'online' | 'busy' | 'offline'

export const AVAIL_OPTIONS: { value: AvailValue; label: string; color: string }[] = [
  { value: 'online',  label: 'Online',  color: '#22c55e' },
  { value: 'busy',    label: 'Ocupado', color: '#f59e0b' },
  { value: 'offline', label: 'Offline', color: '#9ca3af' },
]

const _status = ref<AvailValue>((localStorage.getItem('user_avail') as AvailValue) ?? 'offline')

export const availStatus = _status

// Sincroniza status entre abas: alterar a disponibilidade em uma aba (ex.: ConvDrawer
// ou DashHeader) reflete nas demais sem reload — o evento só dispara nas abas que
// não fizeram a escrita.
window.addEventListener('storage', (e) => {
  if (e.key === 'user_avail' && e.newValue) {
    _status.value = (e.newValue as AvailValue) || 'offline'
  }
})

export function syncAvailStatus(status: string) {
  _status.value = (status.toLowerCase() as AvailValue) || 'offline'
  localStorage.setItem('user_avail', _status.value)
}

const TO_WOOTDASH_STATUS: Record<AvailValue, AgentAvailability> = {
  online: 'Online', busy: 'Busy', offline: 'Offline',
}

// PATCH /agentes/eu/status (auto-serviço, via claim do próprio JWT) — substituiu o PUT
// /profile do Chatwoot + a gravação paralela numa tabela MySQL própria (agent_status,
// mecanismo que existia só porque o Chatwoot não expunha o status de terceiros de forma
// confiável). O WootDash já tem Agent.Status como campo real e único, sem precisar
// dessa duplicação.
export async function updateAvailability(token: string, status: AvailValue): Promise<void> {
  _status.value = status
  localStorage.setItem('user_avail', status)

  const result = await updateOwnStatus(token, TO_WOOTDASH_STATUS[status])
  if (!result.ok) {
    throw new Error('Falha ao atualizar disponibilidade')
  }
}
